import React, { useState, useEffect } from 'react';
import Footer from '../components/footer';
import Header from '../components/header';

const API_GET_BOOKERS = 'https://app.mirzawaleed.com/getBookers.php';
const API_ADD_BOOKER = 'https://app.mirzawaleed.com/addbooker.php';
const API_DELETE_BOOKER = 'https://app.mirzawaleed.com/deletebooker.php';

const BookerPage = () => {
  const [bookers, setBookers] = useState([]);
  const [newBookerName, setNewBookerName] = useState('');

  // Fetch all bookers on component mount
  useEffect(() => {
    fetchBookers();
  }, []);

  const fetchBookers = async () => {
    try {
      const response = await fetch(API_GET_BOOKERS);
      const result = await response.json();
      setBookers(result); // Directly setting the result array to bookers
    } catch (error) {
      console.error('Error fetching bookers:', error);
    }
  };

  const handleAddBooker = async () => {
    if (!newBookerName) return;

    try {
      const response = await fetch(API_ADD_BOOKER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: newBookerName }),
      });
      const result = await response.json();
      if (result.success) {
        setNewBookerName('');
        fetchBookers(); // Refresh the list after adding
      } else {
        alert('Failed to add booker: ' + (result.message || 'Unknown error'));
      }
    } catch (error) {
      console.error('Error adding booker:', error);
    }
  };

  const handleDeleteBooker = async (id) => {
    try {
      const response = await fetch(API_DELETE_BOOKER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id }),
      });
      const result = await response.json();
      if (result.success) {
        fetchBookers(); // Refresh the list after deletion
      } else {
        alert('Failed to delete booker: ' + (result.message || 'Unknown error'));
      }
    } catch (error) {
      console.error('Error deleting booker:', error);
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      <br />
      <div style={{ padding: '20px' }}>
        <h2>Booker Management</h2>

        {/* Add New Booker */}
        <div style={{ marginBottom: '20px' }}>
          <input
            type="text"
            placeholder="Enter booker name"
            value={newBookerName}
            onChange={(e) => setNewBookerName(e.target.value)}
            style={{ padding: '8px', marginRight: '10px', width: '300px' }}
          />
          <button onClick={handleAddBooker} style={{ padding: '8px 16px' }}>
            Add Booker
          </button>
        </div>

        {/* List of Bookers */}
        <ul>
          {bookers.map((booker) => (
            <li
              key={booker.id}
              style={{
                marginBottom: '10px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span>{booker.name}</span>
              <button
                onClick={() => handleDeleteBooker(booker.id)}
                style={{ padding: '4px 8px', color: 'red' }}
              >
                Delete
              </button>
            </li>
          ))}
        </ul>
      </div>
      <br />
      <br />
      <br />
      <Footer />
    </>
  );
};

export default BookerPage;
